import {IBenefit} from '@dazn/lp-web/src/types/benefits.types';
import {getImage} from '@dazn/lp-web/src/utils';
import {IImage} from '@dazn/lp-web/src/types';

export function featuresV2(component: any) {
    if (!component) return;

    let image = {} as IImage;

    const features = [] as IBenefit[];
    component?.fields?.entries?.forEach(({fields, sys}: any) => {
        if (sys?.contentType?.sys?.id === 'AdaptiveImage') {
            image = getImage({fields});
        } else if (sys?.contentType?.sys?.id === 'LPContentItem') {
            features.push({
                title: fields.title,
                description: fields.description,
                logo: getImage(fields?.logo)
            });
        }
    });

    return {
        title: component?.fields?.title ?? '',
        features,
        image,
        componentType: component?.fields?.componentType
    };
}
